// Intl utilities — multi-currency ready.
// All monetary amounts are integer cents + ISO currency code.

export function formatCurrency(amountCents, currency = "EUR", locale) {
  return new Intl.NumberFormat(locale, {
    style: "currency",
    currency,
    maximumFractionDigits: 0,
  }).format(amountCents / 100);
}

export function formatDate(date, locale, options = {}) {
  return new Intl.DateTimeFormat(locale, {
    dateStyle: "long",
    ...options,
  }).format(new Date(date));
}

export function formatDateTime(date, locale, timeZone) {
  return new Intl.DateTimeFormat(locale, {
    dateStyle: "medium",
    timeStyle: "short",
    timeZone,
  }).format(new Date(date));
}

export function formatNumber(value, locale, options = {}) {
  return new Intl.NumberFormat(locale, options).format(value);
}

// Resolve a locale->text map with graceful fallback (en, then any value).
export function localized(map, locale) {
  if (!map) return "";
  return map[locale] || map.en || Object.values(map)[0] || "";
}
